import { $api } from "../generated/client";

type UseGetProductVariantsQueryOptions = {
	shopId: string;
	productId: string;
	enabled?: boolean;
};

export default function useGetProductVariants({
	shopId,
	productId,
	enabled = false,
}: UseGetProductVariantsQueryOptions) {
	return $api.useQuery("get", "/shops/{shopId}/products/{productId}/variants", {
		params: { path: { shopId, productId } },
		enabled: enabled && Boolean(productId),
	});
}
